import { isBlackFridayPeriod } from '@coolblue-development/calendar-events';
import { useRequestContext } from '@coolblue-development/next-request-context/client';
import { Product } from '@features/product/typings';
import { useTranslation } from '@i18n/useTranslation';

import { ExtendedUsp } from './types';

const TELEVISIONS_PRODUCT_TYPE_ID = 2627;

const SIZE_PROPERTY_ID = '15';
const TELEVISION_SIZE_50 = '50';
const TELEVISION_SIZE_98 = '98';

export const GetDefaultExtendedUsps = (
  productTypeId: number,
  properties: Product['properties'],
  dateOverride?: string
): ExtendedUsp[] => {
  const { t } = useTranslation('webshop.extendedUsps');
  const { subsidiary } = useRequestContext();

  if (!isTelevision(Number(productTypeId))) {
    return [];
  }

  if (
    is50InchOrSmallerTelevision(properties) &&
    isBlackFridayPeriod(subsidiary, dateOverride ? new Date(dateOverride) : new Date())
  ) {
    return [
      {
        title: t('50InchOrSmallerTelevision.titleFirst'),
        description: t('50InchOrSmallerTelevision.descriptionFirst')
      }
    ];
  }

  if (isLargeTelevision(properties)) {
    return [
      {
        title: t('largeTelevision.titleFirst'),
        description: t('largeTelevision.descriptionFirst')
      },
      {
        title: t('largeTelevision.titleSecond'),
        description: t('largeTelevision.descriptionSecond')
      }
    ];
  }

  return [
    {
      title: t('default.titleFirst'),
      description: t('default.descriptionFirst')
    },
    {
      title: t('default.titleSecond'),
      description: t('default.descriptionSecond')
    }
  ];
};

const isTelevision = (productTypeId: number) => productTypeId === TELEVISIONS_PRODUCT_TYPE_ID;

const is50InchOrSmallerTelevision = (properties: Product['properties']) =>
  properties?.summary?.find(property => property.propertyId === SIZE_PROPERTY_ID)?.value ??
  '' <= TELEVISION_SIZE_50;

const isLargeTelevision = (properties: Product['properties']) =>
  properties?.summary?.find(property => property.propertyId === SIZE_PROPERTY_ID)?.value ===
  TELEVISION_SIZE_98;
